module.exports = __webpack_public_path__ + "img/instagram.3284b323.png";